import Swiper from 'swiper';
import { Pagination, Autoplay, EffectFade } from 'swiper/modules';

export const initSlider = () => {
    const sliderEls = document.querySelectorAll('.js-swiper');

    sliderEls.forEach((el) => {
        const element = el as HTMLElement;
        const config = element.dataset.swiperConfig;
        const paginationEl = element.querySelector('.swiper-pagination') as HTMLElement;

        // --- 共通の基本設定 ---
        let options: any = {
            modules: [Pagination, Autoplay, EffectFade],
            loop: true,
            autoplay: { delay: 5000 },
            //pagination: { el: paginationEl, clickable: true },
        };

        // --- 個別の設定上書き ---
        switch (config) {
            case 'top-kv':
                options.slidesPerView = "auto";
                options.spaceBetween = 17;
                options.breakpoints = {
                    750: {
                        spaceBetween: 40,
                    }
                };
                break;
        }

        // 初期化
        new Swiper(element, options);
    });
};